export default "__VITE_ASSET__qI4hoGQE__"